import BaseLineupValidatorBuilder from 'services/sports/default/base-lineup-validator-builder';
import BaseValidator from 'services/validations/base-validator';

export default class EditedLineupValidatorClassicBuilder extends BaseLineupValidatorBuilder {
    getInterface({incomingValues = {}}) {
        const {sportConfig, lineupPlayers} = incomingValues;

        const maxPlayersFromOneTeamValidator = this.getMaxPlayersFromOneTeamValidator(sportConfig, lineupPlayers);
        const minTeamsValidator = this.getMinTeamsValidator(sportConfig, lineupPlayers);

        const validator = new BaseValidator();

        validator.addSubValidators([maxPlayersFromOneTeamValidator, minTeamsValidator]);

        return validator;
    }
}
